<script setup lang="ts">
import { LucideLoaderCircle } from 'lucide-vue-next'
import type { AuthResponse } from '~/types/auth'
import { useAuth } from '~/composables/useAuth'

const route = useRoute()
const { getPathWithLocale } = useLocalizedPath()

const id = route.params.id as string
const hash = route.params.hash as string

const { handleAuth, logoutAndRedirectToLogin } = useAuth()
const { checkAndPromptPolicy } = usePrivacyPolicy()

const verifyEmail = async () => {
  const router = useRouter()
  try {
    const { $api } = useNuxtApp()
    const response = await $api<AuthResponse>(`/email/verify/${id}/${hash}`)

    if (response.status === 'success' && response.data) {
      await handleAuth(response)

      await checkAndPromptPolicy(
        async () => await router.push(getPathWithLocale('/?verified=success')),
        logoutAndRedirectToLogin
      )
    } else {
      await router.push(getPathWithLocale('/login?verified=error'))
    }
  } catch (error) {
    console.error('Email verification error:', error)
    await router.push(getPathWithLocale('/login?verified=error'))
  }
}

verifyEmail()
</script>

<template>
  <Main>
    <Container>
      <div class="flex min-h-[50vh] items-center justify-center">
        <div class="mx-auto max-w-xl text-center">
          <div class="mb-4">
            <LucideLoaderCircle class="inline-block h-8 w-8 animate-spin text-blue-600" />
          </div>
          <h1 class="mb-2 text-xl font-semibold">{{ $t('page.email_verify.heading') }}</h1>
          <p class="text-gray-600">{{ $t('page.email_verify.please_wait') }}</p>
        </div>
      </div>
    </Container>
  </Main>
</template>
